import { Input } from "@/components/ui/input";
import { useRouter, useSearch } from "@tanstack/react-router";
import { useDebounce } from "@/lib/hooks/use-debounce";
import { useEffect, useState } from "react";

export function Filters() {
  const router = useRouter();
  const { search } = useSearch({ strict: false }) as Record<string, string>;
  const [searchValue, setSearchValue] = useState(search || "");
  const debouncedSearch = useDebounce(searchValue, 300);

  useEffect(() => {
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: 1,
        search: debouncedSearch || undefined,
      }),
    });
  }, [debouncedSearch, router]);

  return (
    <div className="flex items-center gap-2 p-2">
      <Input
        placeholder="Search triggers..."
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        className="h-8 w-[150px] lg:w-[250px]"
      />
    </div>
  );
}
